const addresses = {
	marketplace: "KT1JoCosSDUHqKPGJuK7BKLKUysX22ZDDN5V",
	FA2: "KT1FUmcWZTmQWVvUx9UscwSDtc2tNnYYe3F4",
	movies: "KT1HHyH8yeUYNWmjfEme3DEirqcGo1VMaY8W",
	admin: "tz1aidV6N2bCCcWNbWvg8GhuxCkXGPvERPeu",
};

export default addresses;
